import { ActionCreator, ReducerTypes, createReducer, on } from '@ngrx/store';

import * as actions from './service-request-payment-input.actions';
import { ServiceRequestPaymentInputState } from './service-request-payment-input.state';

export const serviceRequestPaymentInputInitialState: ServiceRequestPaymentInputState = {
  nextAction: '',
};

export const serviceRequestPaymentInputReducerFeatures: ReducerTypes<
  ServiceRequestPaymentInputState,
  ActionCreator[]
>[] = [
  on(actions.setStateServiceRequestPaymentInput, (_state, payload) => ({ ...payload })),
  on(actions.updateStateServiceRequestPaymentInput, (state, payload) => ({ ...state, ...payload })),
  on(actions.resetStateServiceRequestPaymentInput, () => serviceRequestPaymentInputInitialState),
];

export const serviceRequestPaymentInputReducer = createReducer(
  serviceRequestPaymentInputInitialState,
  ...serviceRequestPaymentInputReducerFeatures
);
